<template>
  <v-dialog v-model="dialogLocal" max-width="500px">
    <v-card>
      <v-card-title>Editar nodo</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="nodoEditando.name"
          label="Nombre del nodo"
          required
        />
        <v-select
          v-model.number="nodoEditando.tipoId"
          :items="tiposNodo"
          item-text="name"
          item-value="id"
          label="Tipo"
          clearable
        >
          <template v-slot:append-item>
            <v-divider class="mt-2"></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="nuevoTipoTexto"
                  label="Crear nuevo tipo"
                  @keyup.enter="crearNuevoTipo"
                />
                <v-file-input
                  v-model="nuevoTipoBanner"
                  label="Banner para nuevo tipo"
                  accept="image/*"
                  show-size
                  clearable
                />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn color="primary" @click="guardarEdicionNodo">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    nodoEditando: Object,
    tiposNodo: Array
  },
  data() {
    return {
      nuevoTipoTexto: '',
      nuevoTipoBanner: null,
      dialogLocal: false,
    }
  },
  watch: {
    dialog(val) {
      this.dialogLocal = val
    },
    dialogLocal(val) {
      if (!val) {
        this.$emit('update:dialog', false)
      }
    }
  },
  mounted() {
    this.dialogLocal = this.dialog
  },
  methods: {
    close() {
      this.$emit('update:dialog', false)
      this.nuevoTipoTexto = ''
      this.nuevoTipoBanner = null
    },
    crearNuevoTipo() {
      if (!this.nuevoTipoTexto) {
        this.$avisar('El texto del nuevo tipo es obligatorio', "warning")
        return
      }
      this.$emit('crear-nuevo-tipo', {
        texto: this.nuevoTipoTexto,
        banner: this.nuevoTipoBanner
      })
      this.nuevoTipoTexto = ''
      this.nuevoTipoBanner = null
    },
    guardarEdicionNodo() {
      if (!this.nodoEditando.name) {
        this.$avisar('El nombre es obligatorio', "warning")
        return
      }
      this.$emit('guardar-edicion', this.nodoEditando)
      this.close()
    }
  }
}
</script>
